import { Module } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { AuthModule } from '../auth/auth.module';
import { AdminCategoriesController, CategoriesController } from './categories.controller';
import { CategoriesRepository } from './categories.repository';
import { CategoriesService } from './categories.service';
import { PrismaCategoriesRepository } from './prisma-categories.repository';

@Module({
  imports: [AuthModule],
  controllers: [CategoriesController, AdminCategoriesController],
  providers: [
    CategoriesService,
    PrismaService,
    {
      provide: CategoriesRepository,
      useClass: PrismaCategoriesRepository,
    },
  ],
})
export class CategoriesModule {}
